module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Terms change","feeName":"Fee name","feeAmount":"Fee amount and date","date":"Date","send":"Activate"},"et":{"title":"Terms change","feeName":"Fee name","feeAmount":"Fee amount and date","date":"Date","send":"Activate"},"ru":{"title":"Terms change","feeName":"Fee name","feeAmount":"Fee amount and date","date":"Date","send":"Activate"}}')
  delete Component.options._Ctor
}
